<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-card>
          <div slot="header" class="flex justify-between">
            <span>拼团信息</span>
          </div>
          <div class="card-body">
            <el-form label-width="100px">
              <el-form-item label="商品">
                <el-col :span="18">
                  <el-input 
                    v-model="formData.prodName" 
                    disabled 
                    placeholder="必填，请填写商品名称"
                  />
                </el-col>
                <el-col :span="6">
                  <el-button 
                    type="primary" 
                    size="small" 
                    @click="openChooseProductModal"
                  >
                    <i class="el-icon-plus"></i>选择商品
                  </el-button>
                </el-col>
              </el-form-item>

              <el-form-item label="拼团名称">
                <el-col :span="11">
                  <el-input 
                    v-model="formData.groupProdName" 
                    placeholder="必填，请填写拼团名称"
                  />
                </el-col>
                <el-col :span="11" :offset="2">
                  <el-input 
                    v-model="formData.sort" 
                    placeholder="必填，请填写拼团排序"
                  />
                </el-col>
              </el-form-item>

              <el-form-item label="拼团简介">
                <el-col :span="23">
                  <el-input
                    type="textarea"
                    v-model="formData.groupProdDesc"
                    placeholder="必填，请填写拼团简介"
                    maxlength="250"
                    show-word-limit
                    rows="4"
                  />
                </el-col>
              </el-form-item>
            </el-form>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="24">
        <el-card>
          <div slot="header" class="flex justify-between">
            <span>商品规格</span>
          </div>
          <div class="card-body">
            <el-table :data="formData.productSpecs" border>
              <el-table-column prop="specName" label="规格名称" align="center" />
              <el-table-column label="规格值" align="center">
                <template slot-scope="scope">
                  <span v-html="scope.row.specValue"></span>
                </template>
              </el-table-column>
              <el-table-column prop="stock" label="库存" align="center" />
              <el-table-column prop="sales" label="销量" align="center" />
              <el-table-column prop="price" label="金额" align="center" />
              <el-table-column prop="costPrice" label="成本价" align="center" />
              <el-table-column label="拼团价" align="center">
                <template slot-scope="scope">
                  <el-input-number 
                    v-model="scope.row.groupPrice" 
                    :min="0" 
                    :precision="2"
                    controls-position="right"
                  />
                </template>
              </el-table-column>
              <el-table-column label="拼团库存" align="center">
                <template slot-scope="scope">
                  <el-input-number 
                    v-model="scope.row.groupStock" 
                    :min="0" 
                    :precision="0"
                    controls-position="right"
                  />
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="24">
        <el-card>
          <div slot="header" class="flex justify-between">
            <span>商品扩展</span>
          </div>
          <div class="card-body">
            <el-form label-width="100px">
              <el-form-item label="活动状态">
                <el-col :span="11">
                  <el-select 
                    v-model="formData.state" 
                    placeholder="选填，请选择状态"
                    style="width:100%"
                  >
                    <el-option label="开启" value="1001" />
                    <el-option label="关闭" value="2002" />
                  </el-select>
                </el-col>
                <el-col :span="11" :offset="2">
                  <el-input 
                    v-model="formData.userCount" 
                    placeholder="必填，请填写拼团人数"
                  />
                </el-col>
              </el-form-item>

              <el-form-item label="商品详情">
                <el-col :span="23">
                  <tinymce 
                    v-model="formData.content" 
                    :height="300"
                  />
                </el-col>
              </el-form-item>
            </el-form>

            <div class="footer-buttons">
              <el-button type="warning" @click="closeAddProduct">
                <i class="el-icon-close"></i>取消
              </el-button>
              <el-button type="primary" @click="saveProductInfo">
                <i class="el-icon-check"></i>保存
              </el-button>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <choose-product ref="chooseProduct" @choose="handleChooseProduct" />
  </div>
</template>

<script>
import { saveGroupBuyProduct } from '@/api/goods/groupBuyProductApi'
import { getShopId } from '@/api/shop/shopApi'
import ChooseProduct from '@/components/goods/chooseProduct/chooseProduct'

export default {
  name: 'AddGroupBuyProduct',
  components: {
    ChooseProduct
  },
  props: {
    callBackListener: String,
    callBackFunction: String
  },
  data() {
    return {
      formData: {
        productId: '',
        groupProdName: '',
        prodName: '',
        groupProdDesc: '',
        sort: '',
        content: '',
        state: '',
        userCount: '3',
        productSpecs: []
      }
    }
  },
  methods: {
    open() {
      this.resetForm()
    },
    resetForm() {
      this.formData = {
        productId: '',
        groupProdName: '',
        prodName: '',
        groupProdDesc: '',
        sort: '',
        content: '',
        state: '',
        userCount: '3',
        productSpecs: []
      }
    },
    openChooseProductModal() {
      this.$refs.chooseProduct.open()
    },
    handleChooseProduct(product) {
      this.formData.productId = product.productId
      this.formData.prodName = product.prodName
      this.formData.groupProdName = product.prodName
      this.formData.groupProdDesc = product.prodDesc
      this.formData.productSpecs = product.productSpecValues.map(item => {
        return {
          ...item,
          groupPrice: 0,
          groupStock: 0,
          specValue: item.productSpecDetails.map(detail => detail.detailValue).join('/')
        }
      })
    },
    validateForm() {
      if (!this.formData.groupProdName) {
        this.$message.error('拼团名称不能为空')
        return false
      }
      if (!this.formData.groupProdDesc) {
        this.$message.error('拼团简介不能为空')
        return false
      }
      if (!this.formData.productId) {
        this.$message.error('请选择商品')
        return false
      }
      if (!this.formData.state) {
        this.$message.error('请选择活动状态')
        return false
      }
      if (!this.formData.userCount) {
        this.$message.error('拼团人数不能为空')
        return false
      }
      return true
    },
    async saveProductInfo() {
      if (!this.validateForm()) return

      try {
        const params = {
          ...this.formData,
          shopId: getShopId()
        }
        await saveGroupBuyProduct(params)
        this.$message.success('添加成功')
        this.closeAddProduct()
        this.$emit('close')
      } catch (error) {
        console.error('添加拼团商品失败:', error)
      }
    },
    closeAddProduct() {
      this.resetForm()
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.card-body {
  padding: 20px;
}
.footer-buttons {
  margin-top: 20px;
  text-align: right;
}
</style>